/* Optional launchers yield to visible shopping controls. Native purchase logic stays intact. */
(() => {
  const page = document.querySelector('[data-herqs-buyflow]');
  if (!page || !('IntersectionObserver' in window)) return;
  const visible = new Set();
  const observed = new Set();
  const update = () => {
    for (const target of visible) if (!target.isConnected) visible.delete(target);
    document.documentElement.classList.toggle('herqs-main-buy-visible', visible.size > 0);
  };
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (entry.isIntersecting) visible.add(entry.target);
      else visible.delete(entry.target);
    }
    update();
  }, { rootMargin: '-56px 0px 0px 0px' });
  function connect() {
    for (const target of observed) {
      if (!target.isConnected) {
        observer.unobserve(target);
        observed.delete(target);
        visible.delete(target);
      }
    }
    page.querySelectorAll('.product-info buy-buttons button[type="submit"], .hq-home #vuurkorven, .collection-view #vuurkorven .product-rich, product-card').forEach(target => {
      if (!observed.has(target)) {
        observed.add(target);
        observer.observe(target);
      }
    });
    update();
  }
  connect();
  document.addEventListener('shopify:section:load', connect);
  // Prestige emits this non-bubbling event before replacing product controls.
  document.addEventListener('product:rerender', () => queueMicrotask(connect), true);
  window.addEventListener('pageshow', connect);
})();
